import { mapMinimalUserData } from 'clients/users/userClient.formatter';

export const mapComment = (comment: any) => ({
  ...comment,
  created_by: mapMinimalUserData(comment.created_by),
  created_at: new Date(comment.created_at),
});
